import styled from 'styled-components';
import themeColors from '../../assets/styles/themeColors';

export const MaskedFieldContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  button {
    position: absolute;
    top: 32px;
    right: 0;
    margin: 12px;
  }

  svg {
    width: 24px;
    height: 24px;
    color: ${themeColors.colorSvgSemidark};
  }

  input {
    padding-right: 42px;
  }
`;
